import { Text, Box, Flex, Image } from "@chakra-ui/react"
import kamilImg from './onas-kamil.webp'

export const AboutUsSection = ({priority}: {priority: 'high' | 'low'}) => {
  return (
    <Flex
      backgroundImage= {'linear-gradient(45deg, secondary 0%, creamy 100%);'}
      borderRadius={4}
      align="flex-start"
      justify={{ base: "space-evenly" }}
      direction={{ base: "column", md: 'row' }}
      gap={2}
    >
        <Box as='div' bgColor={'white'} borderRadius={4} p={4} m={4}>
          <b>Jak się zaczęło?</b>
          <Text p={4}>
            {`Trafiłem niedawno na film dokumentalny o książce De Renner autorstwa Tima Krabbé. W filmie nazwano ją przewrotnie "Eversellerem" — w kolarskiej Holandii niezmiennie od lat jest chętnie wybieraną lekturą, która wzbudza zainteresowanie rowerami i często zaszczepia kolarskiego bakcyla. W Polsce popularność rowerów wciąż pozostaje w tyle za europejskimi liderami. Czy ciekawe i pasjonujące opowieści mogą zainspirować nowych użytkowników ścieżek rowerowych, a może nawet przyszłych triumfatorów wielkich tourów? Tak narodził się pomysł na wydawnictwo.`}
          </Text>
          <b>A dystans?</b>
          <Text p={4}>
            Wierzymy, że pasję do sportu można zgłębiać nie tylko w pocie czoła, wbijając kilometry na leśnych ścieżkach, ale też leniwym popołudniem zanurzając się w książce, z dala od zgiełku. To kameralne wydawnictwo skupia się na dziełach, które ukazują sport z wielu perspektyw i opowiadają historie zbudowane na różnych doświadczeniach. Bez masówki - koncentrujemy się na treściach, które mają coś do powiedzenia. Niezależnie - zaczynamy w formie self-publishingu. Bez ciśnienia - w życiu i w sporcie liczy się dystans.
          </Text>
          <br/>
          <b>Kamil</b>
        </Box>
      <Box m={4} >
        <Image
          loading={priority === 'high' ? "eager" : "lazy"}
          fetchPriority={priority}
          src={kamilImg} 
          alt="Zdjęcie Kamil on nas"
          minWidth={{ base: '300px' }}
          borderRadius={4} 
        />
      </Box>

    </Flex>
  )
}